import React, { useState, useEffect } from "react";
import MobileMenu from "./MobileMenu.jsx";
import "./styles/Navbar.css";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import { useModal } from "../contexts/ModalContext.js";
import { useAuth } from "../contexts/AuthContext.js";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config.js";
import logo from "../assets/newro-beige-logo.svg";
import { CircleUserRound } from "lucide-react";
import { useNavigate } from "react-router";
import SearchIcon from '@mui/icons-material/Search';

const Navbar = ({ pageOn, handleScroll }) => {
  const { user } = useAuth();
  let navigate = useNavigate();
  const { openModal } = useModal();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function navButtonClicked(type) {
    switch (pageOn) {
      case "landing":
        if (type === "about") {
          navigate("/about");
        } else if (type === "connect") {
          navigate("/connect");
        } else {
          handleScroll(type);
        }
        break;
      case "about":
        if (type === "about") {
          navigate("/about");
        } else if (type === "connect") {
          navigate("/connect");
        } else {
          navigate("/#" + type);
          // handleScroll(type)
        }
        break;
      case "event":
        if (type === "about") {
          navigate("/about");
        } else if (type === "connect") {
          navigate("/connect");
        } else {
          navigate("/#" + type);
          // handleScroll(type)
        }
        break;
      default:
        break;
    }
  }

  const displayName = user?.displayName || "Newro User";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {isMobile ? (
        <MobileMenu pageOn={pageOn} handleScroll={handleScroll} />
      ) : (
        <div
          className="navbar"
        >
          <div className="left">
            <div className="logo" onClick={() => navButtonClicked("home")}>
              <img src={logo} alt="logo" className="logo-image" />
              <h1>newro</h1>
            </div>
          </div>
          <div className="right">
            <div className="items">
              <div className="nav-links">
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => navButtonClicked("home")}
                >
                  Home
                </a>
                <a
                  style={{ cursor: "pointer", fontWeight: '600' }}
                  onClick={() => navButtonClicked("connect")}
                >
                  Connect
                </a>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => navButtonClicked("about")}
                >
                  About
                </a>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => navButtonClicked("faq")}
                >
                  FAQ
                </a>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => navButtonClicked("contact")}
                >
                  Contact
                </a>
              </div>
              {user ? (
                <button
                  onClick={() => openModal("profile")}
                  className="loggedin-btn"
                >
                  <div className="profile-btn-text">
                    {displayName.charAt(0).toUpperCase()}
                  </div>
                </button>
              ) : (
                <button
                  onClick={() => openModal("login")}
                  className="login-btn"
                >
                  <div className="login-btn-text">Login</div>
                </button>
              )}

              {/* Search users / connections feature - not implemented yet */}
              {/* <SearchIcon
                className="search-icon"
                onClick={() => openModal("find")}/> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
